import { LoggerFactory } from "../../../logger";
import { map, each, isArray, includes, reduce } from "lodash";
import {
  Completer,
  CompleterInterface,
  CompleterTypes,
  Completion
} from "./completer";
import { Node } from "./graph";

const log = LoggerFactory.create("groupCompleter");

export class GroupCompleter implements CompleterInterface {
  private completers: Completer[];
  private types: CompleterTypes;

  constructor(completionGroups: Node[], types: CompleterTypes) {
    log.debug("init", this);
    this.types = types;

    /*var _types = {
     "rule" : [ "rule" ],
     "function" : [ "function", "rule", "param" ],
     "param" : [ "param" ],
     "variable" : [ "variable" ],
     "action" : [ "function", "actionFunction" ],
     "actionFunction" : [ "actionFunction" ],
     "null" : [ "function", "rule", "param", "variable", "action" ]
     };

    this.types = _types;*/

    this.completers = map(completionGroups, function(completions) {
      return new Completer(completions);
    });
  }

  public getCompletions(
    editor: any,
    session: any,
    pos: number,
    prefix: string,
    callback: (...args: any) => void
  ) {
    log.debug("getCompletions()", arguments, this);

    const completionsObject = {};
    const allCompletions: Completion[] = [];
    const that = this;
    const completionPromises: any = [];
    let currentContext: any = null;
    let currentContextDistance = 1000;

    each(this.completers, completer => {
      var resolvePromise: any;
      var p = new Promise(function(resolve) {
        resolvePromise = resolve;
      });

      completionPromises.push(p);
      completer.getCompletions(
        editor,
        session,
        pos,
        prefix,
        (context, completions, distance) => {
          //context null means it is not inside startSymbol endSymbol of this completer
          //so if it is set (context != null) it means it is currentContext
          //and as we decode line from editor we want to make sure the closest completer
          //to cursor is the one that is set to currentContext

          //distance := cursorColumn - startSymbolColumn
          //distance is set only if context is different than null
          if (context != null && distance < currentContextDistance) {
            currentContext = context;
            currentContextDistance = distance;
          }

          if (!isArray(completionsObject[completer.type])) {
            completionsObject[completer.type] = [];
          }

          completionsObject[completer.type].push(...completions);
          resolvePromise();
        }
      );
    });
    Promise.all(completionPromises).then(function() {
      reduce(
        completionsObject,
        function(
          arr: Completion[],
          _completions: Completion[],
          context: string
        ) {
          const shouldPush = includes(that.types[currentContext], context);

          if (shouldPush) {
            arr.push(..._completions);
          }

          return arr;
        },
        allCompletions
      );

      callback(null, allCompletions);
    });
  }
}
